export default [
  {
    path: 'zhaopin',
    name: 'zhaopin',
    component: () => import('./index'),
  }, {
    path: "zhaopin/info",
    name: "info",
    component: () => import('./info/index.vue')
  }, {
    path: "zhaopin/resourceSwap",
    name: "resourceSwap",
    component: () => import('./resourcesSwap/index.vue')
  }
];


// WEBPACK FOOTER //
// ./src/views/zhaopin/index.route.js